import React from 'react';
import '../Assets/Css/HomeCss/FooterTopBar.css';

const FooterTopBar = () => {
  return (
    <div className="footer-top-bar">
      <div className="support-info">
        <a
          href="https://www.pmdc.pk/"
          target="_blank"
          rel="noopener noreferrer"
          className="support-text support-link"
          title="Verify doctors on the PMDC website"
        >
          <i className="fa-solid fa-badge-check support-icon" aria-hidden="true"></i>
          <p><strong>PMDC Verified Doctors</strong></p>
          <p>Authentic and updated information</p>
        </a>

        <div className="support-text">
          <i className="fa-solid fa-headset support-icon" aria-hidden="true"></i>
          <p><strong>Reliable Customer Support</strong></p>
          <p>7 days a week</p>
        </div>

        <div className="support-text">
          <i className="fa-solid fa-shield-check support-icon" aria-hidden="true"></i>
          <p><strong>Secure Online Payments</strong></p>
          <p>Secure checkout using SSL certificate</p>
        </div>
      </div>
    </div>
  );
};

export default FooterTopBar;
